<app-article-form
  [initialValues]="initialValues"
  [isSubmitting]="isSubmitting$ | async"
  [errors]="errors$ | async"
  (articleSubmitEvent)="onSubmit($event)"
></app-article-form>
